// Central API configuration constants
export const API_BASE_URL = process.env.REACT_APP_BASE_URL;
console.log(`[SYS INFO] The API_BASE_URL loaded at build-time is: "${API_BASE_URL || 'UNDEFINED/BLANK'}"`);
